export class CodedError extends Error {
  code: string;

  constructor(message: string, code: string) {
    super(message);
    this.name = "CodedError";
    this.code = code;
  }
}